export enum GatewayNamespaces {
  NOTIFICATIONS = 'notifications',
}
